import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {DEFAULT_LANGUAGE_TAG} from 'i18n/LanguageTagConstants';
import {ControlledLanguagePickerInput} from 'i18n/LanguageTags';

interface ProfileLanguagePickerProps {
  name: string;
  initialValue: string | null;
}

export default function ProfileLocalePicker(props: ProfileLanguagePickerProps): JSX.Element {
  const [languageTag, setLanguageTag] = useState<string>(props.initialValue ?? DEFAULT_LANGUAGE_TAG.code);
  return (
    <>
      <ControlledLanguagePickerInput
        languageTag={languageTag}
        date={new Date()}
        onSelect={(newLanguageTag) => {
          setLanguageTag(newLanguageTag);
        }}
      />
      <input
        id={props.name}
        className={css(styles.hiddenInput)}
        name={props.name}
        tabIndex={-1}
        type="hidden"
        value={languageTag}
      />
    </>
  );
}

const styles = StyleSheet.create({
  hiddenInput: {
    display: 'none',
  },
});
